import { del, get, put } from 'services/request';
import { ITranslationBankItemEdit } from 'types/translationBank';
import { BaseModel } from './BaseModel';
import { TranslationBankItemsModel } from './TranslationBankItemsModel';
import TranslationManagerModel from './TranslationManagerModel';

export interface ITranslationBankItemModelOptions {
  render: () => void;
  itemId: number;
  ref: number;
  itemsModel: TranslationBankItemsModel;
  onDelete?: () => void;
}

export class TranslationBankItemModel extends BaseModel<any, ITranslationBankItemEdit> {
  itemsModel: TranslationBankItemsModel;
  translations: TranslationManagerModel;
  onDelete?: () => void;

  constructor(options: ITranslationBankItemModelOptions) {
    super(options);
    this.ref = options.ref;
    this.itemsModel = options.itemsModel;
    this.onDelete = options.onDelete;
    this.translations = new TranslationManagerModel({ ref: options.ref });
    this.loadItemEdit(options.itemId);
  }

  async loadItemData(itemId: number) {
    const [item, sources] = await Promise.all([
      get<ITranslationBankItemEdit>(`/translation-bank-items/${itemId}`),
      this.translations.get(itemId),
    ]);
    item.sources = sources;
    return item;
  }

  async save() {
    await super.save();
    await this.updateItem();
  }

  async updateItem() {
    const item = this.itemUpdated as ITranslationBankItemEdit;
    const sources = item.sources;

    // Update translations and notes in parallel
    await Promise.all([
      this.translations.update(item.id, sources),
      put(`/translation-bank-items/${item.id}`, { notes: item.notes }),
    ]);

    // Update grid row and reload item edit
    await Promise.all([this.itemsModel.updateGridRow(item.id, 'update'), this.loadItemEdit(item.id)]);
  }

  async reloadItem() {
    if (this.itemId !== this.NEW_CREATE_ID) {
      await this.loadItemEdit(this.itemId);
    }
  }

  async delete() {
    await super.delete();
    const item = this.itemUpdated as ITranslationBankItemEdit;
    const result = await del(`/translation-bank-items/${item.id}`);

    if (result.ok) {
      await this.itemsModel.updateGridRow(item.id, 'remove');

      // Clear selection after delete
      if (this.onDelete) {
        this.onDelete();
      }
    } else {
      console.error(JSON.stringify(result.data));
    }
    this.itemUpdated = undefined;
    this.loadingItem = false;
    this.render();
  }
}
